/**
 * Created by maxime on 2016-06-20.
 */
import { Timer } from './../../JiveSessionUtils';
var DTMFSender = /** @class */ (function () {
    function DTMFSender(_audioCtx, _destination) {
        this._audioCtx = _audioCtx;
        this._destination = _destination;
        this._DURATION = 100;
        this._INTER_TONE_GAP = 60;
        this._INTER_TONE_PAUSE = 2000;
        this._GAIN = 0.05;
        this._toneBuffer = '';
        this._f1Oscillator = null;
        this._f2Oscillator = null;
        this._playing = false;
        // DTMF tones played for user feedback over their speakers are being caught by the user's mic and
        // end up in the audio signal. This causes the end receiver to process both the out-of-band dtmf signal,
        // and the tones coming over the call audio channel.
        // We take average of the two closest standard vertical/horizontal frequencies. For ex. (697 + 770) / 2 = 733
        // so that they are not misinterpreted as in-band dtmf tones by the end receiver.
        this._freq = ({
            '1': [1272, 733],
            '2': [1406, 733],
            '3': [1555, 733],
            'a': [1715, 733],
            '4': [1272, 811],
            '5': [1406, 811],
            '6': [1555, 811],
            'b': [1715, 811],
            '7': [1272, 896],
            '8': [1406, 896],
            '9': [1555, 896],
            'c': [1715, 896],
            '*': [1272, 991],
            '0': [1406, 991],
            '#': [1555, 991],
            'd': [1715, 991]
        });
        this._volume = this._audioCtx.createGain();
        this._volume.gain.value = this._GAIN;
        this._volume.connect(this._destination);
    }
    Object.defineProperty(DTMFSender.prototype, "duration", {
        get: function () {
            return this._DURATION;
        },
        set: function (duration) {
            this._DURATION = duration;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DTMFSender.prototype, "interToneGap", {
        get: function () {
            return this._INTER_TONE_GAP;
        },
        set: function (gap) {
            this._INTER_TONE_GAP = gap;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DTMFSender.prototype, "interTonePause", {
        get: function () {
            return this._INTER_TONE_PAUSE;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DTMFSender.prototype, "toneBuffer", {
        get: function () {
            return this._toneBuffer;
        },
        set: function (tones) {
            this._toneBuffer = tones;
        },
        enumerable: true,
        configurable: true
    });
    DTMFSender.prototype.insertDTMF = function (tones, duration, interToneGap) {
        var _this = this;
        if (/[^0-9a-d#\*,]/i.test(tones)) {
            throw (new Error('InvalidCharacterError'));
        }
        this.duration = Math.min(6000, Math.max(40, duration || this._DURATION));
        this.interToneGap = Math.max(40, interToneGap || this._INTER_TONE_GAP);
        this.toneBuffer = tones;
        if (!this._playing) {
            Timer.create(function () { return _this._playNextTone(); }, 0);
            this._playing = true;
        }
    };
    DTMFSender.prototype.stopDTMF = function () {
        // Empty out the tone buffer.
        // This lets the current tone finish playing, but prevents subsequent ones.
        this.toneBuffer = '';
    };
    DTMFSender.prototype._cleanOscillators = function () {
        if (this._f1Oscillator) {
            this._f1Oscillator.stop();
            this._f1Oscillator.disconnect();
            this._f1Oscillator = null;
        }
        if (this._f2Oscillator) {
            this._f2Oscillator.stop();
            this._f2Oscillator.disconnect();
            this._f2Oscillator = null;
        }
    };
    DTMFSender.prototype.close = function () {
        this._volume.disconnect();
        this._cleanOscillators();
    };
    DTMFSender.prototype._playNextTone = function () {
        var _this = this;
        if (this._audioCtx) {
            if (this.toneBuffer.length === 0) {
                this._playing = false;
                this._cleanOscillators();
                return;
            }
            var digit = this.toneBuffer.substr(0, 1);
            this.toneBuffer = this.toneBuffer.substr(1);
            if (digit === ',') {
                Timer.create(function () { return _this._playNextTone(); }, this.interTonePause);
                return;
            }
            // Audio nodes can't have start called on them multiple times, so we recreate instead of reusing
            this._f1Oscillator = this._audioCtx.createOscillator();
            this._f1Oscillator.frequency.value = 0;
            this._f1Oscillator.connect(this._volume);
            this._f2Oscillator = this._audioCtx.createOscillator();
            this._f2Oscillator.frequency.value = 0;
            this._f2Oscillator.connect(this._volume);
            var freq = this._freq[digit.toLowerCase()];
            if (freq) {
                this._f1Oscillator.frequency.value = freq[0];
                this._f2Oscillator.frequency.value = freq[1];
                this._f1Oscillator.start(0);
                this._f2Oscillator.start(0);
                Timer.create(function () { return _this._stopTone(); }, this.duration);
                return;
            }
            Timer.create(function () { return _this._playNextTone(); }, 0);
        }
    };
    DTMFSender.prototype._stopTone = function () {
        var _this = this;
        this._cleanOscillators();
        Timer.create(function () { return _this._playNextTone(); }, this.interToneGap);
    };
    return DTMFSender;
}());
export default DTMFSender;
//# sourceMappingURL=DTMFManager.js.map